//////////////////////////////////////////////////////   
//                                                  //   
//  PARA TODOS OS USUÁRIOS:                         //   
//                                                  //   
//  APARECE COMO UMA LUPA E UMA CAIXA               //   
//  DE TEXTO NO HEADER DA PÁGINA HOME               //   
//                                                  //   
//  FUNCIONALIDADE: FILTRAR PRODUTOS                //
//    POR TEXTO DE FORMA GERAL                      //    
//                                                  //   
//////////////////////////////////////////////////////   



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/header.js                               //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import '../../assets/css/local/header.css';
import jQuery from 'jquery'

function Pesquisar(props) {

    function filtrar_produtos_texto(){  // FUNÇÃO PARA EXECUÇÃO DO FILTRO
        // FUNÇÃO CHAMADA NA ALTERAÇÃO DO VALOR DO INPUT 'filtro_por_texto' DESTE COMPONENTE

        window.stop()  // PARA EXECUÇÃO DE OUTRAS QUERIES

        var grupo = []  // PEGA INFORMAÇÕES DOS OUTROS FILTROS
        for (var i=1; i < jQuery('.ui').length; i++){
            grupo.push(jQuery('.ui')[i].innerText)
        }
    
        var preco_minimo = jQuery('.tamanho-filtro')[1].value
        var preco_maximo = jQuery('.tamanho-filtro')[2].value
        var ordem = jQuery('.tamanho-filtro')[3].value

        var dict_ordem = {
            '---------': '[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO ',
            'Maior Preço': '[Grupo_Imaginarium].[dbo].[PRODUTOS_PRECOS].PRECO1 DESC ',
            'Menor Preço': '[Grupo_Imaginarium].[dbo].[PRODUTOS_PRECOS].PRECO1 ',
            'Lançamentos': '[Grupo_Imaginarium].[dbo].[PRODUTOS].DATA_CADASTRAMENTO ',
            // 'Populares': '[Grupo_Imaginarium].[dbo].[PRODUTOS_PRECOS].PRECO1 ',
            // 'Promoções': '[Grupo_Imaginarium].[dbo].[PRODUTOS_PRECOS].PRECO1 ',
        }

        console.log(ordem)
        console.log(dict_ordem[ordem])

        var dict_filtro = {'grupo': grupo.toString(), 'preco_minimo': preco_minimo, 'preco_maximo': preco_maximo, 'ordem': dict_ordem[ordem]}  // COM OS FILTROS 
                                                                                                                    // DEFINE O DICIONÁRIO QUE VAI SER PASSADO COMO PARÂMETRO

        jQuery('#loader').removeClass('d-none')  // APARECE O LOADER
    
        var texto = document.getElementById('filtro_por_texto').value

        var inicio = props.callback(JSON.stringify(dict_filtro), texto)  // E CHAMA A FUNÇÃO 'search_produtos' DO ARQUIVO 'frontend/src/pages/home.js'
        console.log(inicio)
    }

    return (
        <div className="col-xl-6 col-5 header-size">
            <div className="busca col-12 row mx-0 my-1">
                <div className="col-1 pl-2 pr-0 h-100">
                    <i className="fas fa-search py-2 lightgrey h-100"></i>
                </div>
                <div className="col-11 h-100 mx-0">
                    <input id="filtro_por_texto" className="w-100 h-100 py-1 no-outline no-border" placeholder="Pesquisar por produto" onKeyUp={filtrar_produtos_texto}></input>
                </div>
            </div>
        </div>
    );
  }

  export default Pesquisar;
  